import {
  GET_CUSTOMER,
  GET_CUSTOMER_FAIL,
  GET_CUSTOMER_SUCCESS,
  GET_CUSTOMERS,
  GET_CUSTOMERS_FAIL,
  GET_CUSTOMERS_SUCCESS,
  ADD_NEW_CUSTOMER,
  ADD_CUSTOMER_SUCCESS,
  ADD_CUSTOMER_FAIL,
  UPDATE_CUSTOMER,
  UPDATE_CUSTOMER_SUCCESS,
  UPDATE_CUSTOMER_FAIL,
  DELETE_CUSTOMER,
  DELETE_CUSTOMER_SUCCESS,
  DELETE_CUSTOMER_FAIL,
  SET_STATE_CUSTOMER,
  UPDATE_CUSTOMER_STATUS
} from "./actionTypes"

export const setState = ( loading ) => ({
  type: SET_STATE_CUSTOMER,
  payload: loading,
})

export const getCustomers = ( params ) => ({
  type: GET_CUSTOMERS,
  payload: { params },
})

export const getCustomersSuccess = (customers, totalPages, currentPage) => ({
  type: GET_CUSTOMERS_SUCCESS,
  payload: {customers:customers, total:totalPages, currentPage:currentPage}
})

export const getCustomersFail = error => ({
  type: GET_CUSTOMERS_FAIL,
  payload: error,
})

export const addNewCustomer = customer => ({
  type: ADD_NEW_CUSTOMER,
  payload: customer,
})

export const addCustomerSuccess = customer => ({
  type: ADD_CUSTOMER_SUCCESS,
  payload: customer,
})  

export const addCustomerFail = error => ({
  type: ADD_CUSTOMER_FAIL,
  payload: error,
})

export const updateCustomer = customer => ({
  type: UPDATE_CUSTOMER,
  payload: customer,
})

export const updateCustomerStatus = customer => ({
  type: UPDATE_CUSTOMER_STATUS,
  payload: customer,
})

export const updateCustomerSuccess = customer => ({
  type: UPDATE_CUSTOMER_SUCCESS,
  payload: customer,
})

export const updateCustomerFail = error => ({
  type: UPDATE_CUSTOMER_FAIL,
  payload: error,
})

export const deleteCustomer = customer => ({
  type: DELETE_CUSTOMER,
  payload: customer,
})

export const deleteCustomerSuccess = id => ({
  type: DELETE_CUSTOMER_SUCCESS,
  id,
})

export const deleteCustomerFail = error => ({
  type: DELETE_CUSTOMER_FAIL,
  payload: error,
})

export const getCustomer = () => ({
  type: GET_CUSTOMER,
})

export const getCustomerSuccess = customer => ({
  type: GET_CUSTOMER_SUCCESS,
  payload: customer,
})

export const getCustomerFail = error => ({
  type: GET_CUSTOMER_FAIL,
  payload: error,
})
